import React, { useContext, useEffect, useRef } from 'react'
import styles from '../styles/modal.module.css'
import StateContext from '../context/state/StateContext'
import AddTicket from './AddTicket'
import UpdatTicket from './UpdatTicket'
import Loading from './Loading'
import Confirm from './Confirm'
import AddGroup from './AddGroup'
import ProfileUpdate from './ProfileUpdate'
import AddAgency from './AddAgency'
import AddRequest from './AddRequest'
import AddTag from './AddTag'

const Modal = () => {

    const { modal, setModal } = useContext(StateContext)

    const modalRef = useRef();

    const handleModelCLickedOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setModal({ open: false, component: '' });
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleModelCLickedOutside);
        return () => {
            document.removeEventListener('mousedown', handleModelCLickedOutside);
        };
    }, []);

    const component = () => {
        if (modal.component == "Add") {
            return <AddTicket close={setModal} />
        } else if(modal.component == "Update") {
            return <UpdatTicket close={setModal} />
        } else if(modal.component == "Confirm") {
            return <Confirm close={setModal} />
        } else if(modal.component == "Group"){
            return <AddGroup close={setModal} />
        } else if(modal.component == "ProfileUpdate"){
            return <ProfileUpdate close={setModal} />
        } else if(modal.component == "Agency"){
            return <AddAgency close={setModal} />
        } else if(modal.component == "AddRequest"){
            return <AddRequest close={setModal} />
        } else if(modal.component == "AddTag"){
            return <AddTag close={setModal} />
        }
    }


    return (
        <>
            <div className={`${styles.modal} ${modal.open ? styles.active : ''}`}>
                <div className={styles.backDrop}></div>
                <div className={styles.box} ref={modalRef}>
                    <Loading />
                    {component()}
                </div>
            </div>
        </>
    )
}

export default Modal

